import { InjectionToken } from '@angular/core';

export interface investorPortalSettings {
  appInsightsInstrumentationKey: string | null;
}

export const defaultSettings: investorPortalSettings = {
  appInsightsInstrumentationKey: null
};

export const PORTAL_SETTINGS = new InjectionToken<investorPortalSettings>('PORTAL_SETTINGS');
